<template>
  <div class="block">
    <img src="../assets/images/studio.jpg" alt="" />
    <div
      class="position-absolute bottom-0 start-50 translate-middle-x w-100 background-filter"
    >
      <div id="hoerbuecher-intro">
        <div class="container">
          <div class="mobile-hoerbuch">
            <h1 class="header-title mt-5">Hörbuch & Hörspiel</h1>
            <div class="text-white fs-3 fw-light">
              Hier wirst du gut aufgenommen: In stilvoller Umgebung mit höchster
              Soundqualität in angenehmer Atmosphäre
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 575.98px) {
  .mobile-hoerbuch {
    width: 50%;
  }
}

#hoerbuecher-intro {
  padding: 5rem 0;
}

.block {
  position: relative;
  width: 100%;
  height: 100%;
}

img {
  width: 100%;
  height: 90.5vh;
  object-fit: cover;
}

.background-filter {
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgb(0, 0, 0, 0.99) 0%,
    rgba(0, 0, 0, 0.66) 50%,
    rgba(0, 0, 0, 0) 100%
  );
}
</style>
